export interface Theme {
  id: string;
  name: string;
  description: string;
  bodyClass: string;
}

export const themes: Theme[] = [
  { id: "clean", name: "Clean", description: "Minimal white, good typography", bodyClass: "theme-clean" },
  { id: "dark", name: "Dark", description: "Dark background, light text", bodyClass: "theme-dark" },
  { id: "paper", name: "Paper", description: "White background, black text", bodyClass: "theme-paper" },
];

export function getTheme(id: string): Theme {
  return themes.find((t) => t.id === id) ?? themes[0];
}

export interface ColorPreset {
  id: string;
  name: string;
  accent: string;
  accentHover: string;
}

export const colorPresets: ColorPreset[] = [
  { id: "copper", name: "Copper", accent: "#E8915A", accentHover: "#D47A45" },
  { id: "ocean", name: "Ocean", accent: "#3B82F6", accentHover: "#2563EB" },
  { id: "emerald", name: "Emerald", accent: "#10B981", accentHover: "#059669" },
  { id: "rose", name: "Rose", accent: "#F43F5E", accentHover: "#E11D48" },
  { id: "violet", name: "Violet", accent: "#8B5CF6", accentHover: "#7C3AED" },
  { id: "amber", name: "Amber", accent: "#F59E0B", accentHover: "#D97706" },
  { id: "teal", name: "Teal", accent: "#14B8A6", accentHover: "#0D9488" },
  { id: "pink", name: "Pink", accent: "#EC4899", accentHover: "#DB2777" },
  { id: "black", name: "Black", accent: "#1A1A1A", accentHover: "#000000" },
];

export function getColorPreset(id: string): ColorPreset {
  return colorPresets.find((c) => c.id === id) ?? colorPresets[0];
}
